export default __webpack_public_path__ + "static/media/video.e9b9cee8.png";